<template>
  <v-btn
    v-for="(navItem, idx) in inventoryNav?.subItems"
    :key="`inventory-nav-${idx}`"
    :to="navItem.to"
    class="ma-sm-2 my-2"
    size="large"
    color="grey-darken-4"
    variant="flat"
    block
  >
    <span style="white-space: normal; text-align: center">
      {{ navItem.label }}
    </span>
  </v-btn>
</template>

<script setup>
const storeLeftNav = useLeftNavStore()
onMounted(() => storeLeftNav.loadNavConfig())
const inventoryNav = computed(() => storeLeftNav.nav.find((n) => n.label == 'INVENTORY'))
</script>
